import { Caption, css, Mode, styled } from 'canoe';

export const PositionBox = styled.div<{ mode: Mode }>`
  ${({ theme, mode }) => css`
    background: transparent;
    padding: ${theme.spaces.xs};
    border-radius: ${theme.borderRadius.small};
    display: flex;
    flex-direction: column;
    gap: ${theme.spaces.xs};
    align-items: center;

    ${mode === 'Dark'
      ? css`
          border: 2px solid ${theme.colors.OnyxGrayL10};
        `
      : css`
          border: 1px solid ${theme.colors.GlitterGray};
        `}
  `}
`;

export const PositionBoxLabel = styled(Caption)<{ mode: Mode }>`
  ${({ theme, mode }) => css`
    font-size: 13px;
    margin: 0;

    ${mode === 'Dark'
      ? css`
          color: ${theme.colors.White};
        `
      : css`
          color: ${theme.colors.OnyxGray};
        `}
  `}
`;

export const PositionSelectorWrapper = styled.div<{ mode?: Mode }>`
  ${({ theme, mode }) => css`
    width: 113px;
    height: 82px;
    border-radius: ${theme.borderRadius.small};
    padding: ${theme.spaces.xs};
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: ${theme.spaces.s} ${theme.spaces.l};

    ${mode === 'Dark'
      ? css`
          background: ${theme.colors.OnyxGray};
          border: 1px solid ${theme.colors.OnyxGrayL30};
        `
      : css`
          background: ${theme.colors.GlitterGrayL20};
          border: 1px solid ${theme.colors.GlitterGray};
        `}
  `}
`;

export const PositionSelectorColumn = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export const PositionSelectorButton = styled.button<{ isSelected?: boolean; mode?: Mode }>`
  ${({ theme, isSelected, mode }) => css`
    width: 10px;
    height: 10px;
    outline: none;
    border: 0 none;
    padding: 0;
    cursor: pointer;

    background-color: ${theme.colors.OnyxGrayL30};

    ${isSelected &&
    css`
      ${mode === 'Dark'
        ? css`
            background-color: ${theme.colors.Success};
          `
        : css`
            background-color: ${theme.colors.BrandPurple};
          `}
    `}
    &:active,
    &:focus,
    &:focus-within {
      outline: none;
    }
  `}
`;
